import { ReactNode } from 'react';
import ProtectedRoute from './ProtectedRoute';
import { ROLES } from '../types';

interface AdminRouteProps {
  children: ReactNode;
}

export default function AdminRoute({ children }: AdminRouteProps) {
  return (
    <ProtectedRoute allowedRoles={ROLES.ADMIN} redirectTo="/dashboard">
      {children}
    </ProtectedRoute>
  );
}
